module.exports = __webpack_public_path__ + "img/firefox.c3a22b0b.svg";